module.exports = __webpack_public_path__ + "img/logo.703e3a7a.png";